import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
import { ref, useTemplateRef, onMounted, onBeforeUnmount } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'base-dropdown',
    props: {
        disabled: { type: Boolean, default: false }
    },
    setup(__props) {
        const dropdownRef = useTemplateRef('dropdownRef');
        const isOpen = ref(false);
        function onToggle() {
            if (__props.disabled) {
                return;
            }
            toggle();
        }
        function toggle() {
            isOpen.value = !isOpen.value;
            if (isOpen.value) {
                document.addEventListener('click', closeDropdown);
            }
            else {
                document.removeEventListener('click', closeDropdown);
            }
        }
        function closeDropdown(event) {
            const target = event.target;
            if (!target) {
                return;
            }
            if (!dropdownRef.value?.contains(target)) {
                isOpen.value = false;
                document.removeEventListener('click', closeDropdown);
            }
        }
        function handleKeyPress(event) {
            if (event.key === 'Escape') {
                isOpen.value = false;
                document.removeEventListener('click', closeDropdown);
            }
        }
        onMounted(() => {
            document.addEventListener('keydown', handleKeyPress);
            document.addEventListener('click', closeDropdown);
        });
        onBeforeUnmount(() => {
            document.removeEventListener('keydown', handleKeyPress);
            document.removeEventListener('click', closeDropdown);
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                ref_key: "dropdownRef",
                ref: dropdownRef,
                class: _normalizeClass(_ctx.$style.dropdown)
            }, [
                _createElementVNode("div", null, [
                    _renderSlot(_ctx.$slots, "default", { onToggle: onToggle })
                ]),
                (isOpen.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(_ctx.$style.container)
                    }, [
                        _renderSlot(_ctx.$slots, "menu", { onToggle: onToggle })
                    ], 2))
                    : _createCommentVNode("", true)
            ], 2));
        };
    }
});
